import type { Map } from "leaflet";

/** Leaflet 1.9.4 leaves its CSS zoom-end timeout alive after remove(). */
export function removeLeafletMap(map: Map): void {
  // remove() stops fly/pan animations but does not reset this flag. The pending
  // _onZoomTransitionEnd callback checks it before accessing the deleted map pane.
  // Keep this version-specific workaround here rather than patching Leaflet globally.
  (map as Map & { _animatingZoom?: boolean })._animatingZoom = false;
  map.remove();
}
